import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      // main colors
      light: "#d4e8e6",
      main: "#4e5d60",
      dark: "#333",
      //Colors for each server
    },
    secondary: {
      light: "#0066ff",
      main: "#0044ff",
      // dark: will be calculated from palette.secondary.main,
      contrastText: "#ffcc00",
    },
    third: {
      light: "#0066ff",
      main: "#fff",
      // dark: will be calculated from palette.secondary.main,
      contrastText: "#ffcc00",
    },
    buttons: {
      main: "linear-gradient(to right , #e4bc40 20%, #e4bc40)",
      first: "#333",
      second: "#2f4244",
      third: "#e4bc40",
      light: "linear-gradient(to right , #c1d430 20%, #2a9986)",
      dark: "linear-gradient(to right , #2a9986 20%, #2f4244)",
    },
  },
  typography: {
    fontFamily: ["Poppins", "sans-serif"].join(","),
    fontSize: 12,
  },
  textField: {
    width: "100%",
    marginLeft: "auto",
    marginRight: "auto",
    paddingBottom: 0,
    marginTop: 0,
    fontWeight: 500,
    borderRadius: 20,
  },
  cardMax300: {
    //background: "#f3f3fe",
    maxWidth: 400,
    borderRadius: 5,
    boxShadow: " rgba(0, 0, 0, 0.35) 0px 5px 15px",
  },
  GridMax800: {
    maxWidth: 850,
    height: "35vh",
    maxHeight: 300,
    margin: "auto",
  },
});
